import "./style.scss";

type ButtonContainerProps = {
	content: React.ReactNode;
	href: string;
};

export const ButtonContainer = ({ content, href }: ButtonContainerProps) => {
	return (
		<a className="button-container" href={href}>
			{content}
		</a>
	);
};

export default ButtonContainer;
